export default "__VITE_ASSET__D149I3Qb__";